<template>
  <v-container>
    <v-app-bar
      app
      color="indigo"
      dark>
      <v-btn icon @click="closeActiveStory"><v-icon>arrow_back</v-icon></v-btn>

      <v-toolbar-title>{{activeStoryName}}</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="saveActiveStory">
        <v-icon>save</v-icon>
      </v-btn>
    </v-app-bar>

    <v-container
      class="fill-height"
      fluid>
      <v-row
        align="center"
        justify="center">
        <v-col class="text-center">
          <div v-if="activeStory" class="viewer_container">
            <StoryViewer class="storyviewer" />  
            <v-text-field solo v-model="command" v-on:keyup.enter="runCommand(command)" />
          </div>
          <div v-else>
            No story loaded.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import StoryViewer from '../StoryViewer.vue'
import { mapState } from 'vuex'

export default {
  name: 'Editor',
  data: function() {
    return {
      moveable: {
        draggable: true
      },
      command: '',
      commands: [
        '/roll <diceNotation>',
        '/ask [modifier] <question>'
      ]
    }
  },
  computed: {
    ...mapState(['activeStory']),
    activeStoryName() {
      if(!this.$store.state.activeStory) {
        return "No story loaded"
      }
      return this.$store.state.activeStory.name
    },
    events() {
      if(this.$store.state.activeStory == null) {
        return []
      }
      return this.$store.state.activeStory.events
    }
  },
  watch: {
    events() {
      this.$vuetify.goTo(document.body.scrollHeight)
    }
  },
  props: {
    msg: String
  },
  methods: {
    runCommand: function(command) {
      if(command.startsWith('/roll')) {
        this.$store.dispatch('addRoll')
      } else {
        this.$store.dispatch('addSay', {
          type: 'say',
          text: this.command
        })
      }
    
      this.command = ''
    },
    closeActiveStory() {
      this.$router.push('/stories')
    },
    saveActiveStory() {
      this.$store.dispatch('saveActiveStory')
    },
  },
  created() {
    if (!this.activeStory) {
      this.$router.push('/stories')
    }
  },
  components: {
    StoryViewer
  }
}
</script>

<style scoped>

</style>
